import React, { useState, useEffect } from 'react';
import { func, number, bool } from 'prop-types';

import { ALERT_TYPE, Loading, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';

import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import FormError from '../../common/FormError';
import FormLabel from '../../common/FormLabel';
import Modal from '../../common/Modal';
import {TIPS} from '../../../consts/tips';


const PerfilModal = (props) => {

  //variables
  const entityInit = {
    id: 0,
    codigo: '',
    nombre: ''
  };

  //hooks
  const [state, setState] = useState({
    loading: false,
    entity: entityInit
  });

  const [perfiles, setPerfiles] = useState([]);

  const mount = () => {

    if (props.id > 0) {
      FindPerfil();
    }

    if (props.data.listPerfiles.length > 0) {
      setPerfiles(props.data.listPerfiles)
    }

    const unmount = () => {}
    return unmount;
  }
  useEffect(mount, []);

  const [ formValues, formHandle, formReset, formSet ] = useForm({
    codigo: '',
    nombre: ''
  });

  const { errorOf, validate } = useFormErrors(getErrors);

  //handles
  const handleClickAceptar = () => {
    if (!validate()) return;

    if (props.id == 0) {
      AddPerfil();
    }
    else {
      ModifyPerfil();
    }
  };

  //callbacks
  const callbackNoSuccess = (response) => {
      response.json()
      .then((error) => {
        const message = error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
      })
      .catch((error) => {
          const message = 'Error procesando respuesta: ' + error;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
            return {...prevState, loading: false};
          });
      });
  }
  const callbackError = (error) => {
      const message = 'Error procesando solicitud: ' + error.message;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      setState(prevState => {
        return {...prevState, loading: false};
      });
  }

  //funciones
  function getErrors() {

    const errors = {};

    if (formValues.codigo.length === 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED;
    else if (perfiles.includes(formValues.codigo.toLowerCase())) errors.codigo = 'El código de perfil ya existe';

    if (formValues.nombre.length === 0) errors.nombre = VALIDATION_MESSAGE.REQUIRED;

    return errors;
  }

  function FindPerfil() {
    
    setState(prevState => {
      return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        response.json()
        .then((data) => {
            setState(prevState => {
              return {...prevState, loading: false, entity: data};
            });
            formSet({
              codigo: data.codigo,
              nombre: data.nombre
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
        });
    };

    const paramsUrl = `/${props.id}`;

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.PERFIL,
        paramsUrl,
        null,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

  }

  function AddPerfil() {
    const method = REQUEST_METHOD.POST;
    const paramsUrl = null;
    SavePerfil(method, paramsUrl);
  }

  function ModifyPerfil() {
    const method = REQUEST_METHOD.PUT;
    const paramsUrl = `/${props.id}`;
    SavePerfil(method, paramsUrl);
  }

  function SavePerfil(method, paramsUrl) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
      response.json()
      .then((row) => {
        setState(prevState => {
            return {...prevState, loading: false};
        });
        props.onConfirm(row.id);
      })
      .catch((error) => {
        const message = 'Error procesando respuesta: ' + error;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
      });
    };

    const dataBody = {
      ...state.entity,
      codigo: formValues.codigo,
      nombre: formValues.nombre
    };

    ServerRequest(
        method,
        null,
        true,
        APIS.URLS.PERFIL,
        paramsUrl,
        dataBody,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

  }

  return (
    <>

    <Loading visible={state.loading}></Loading>

    <Modal
      size="md"
      title={`Perfil: ${(props && props.id > 0) ? state.entity.nombre : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.PERFIL_MODAL}
      onEscape={() => props.onDismiss()}
      body={(<>
            <div className="col-12">
                <FormLabel htmlFor="codigo" required>Código</FormLabel>
                <input
                    name="codigo"
                    type="text"
                    placeholder="Código"
                    className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                    value={ formValues.codigo }
                    onChange={ formHandle }
                    disabled={props.disabled}
                />
                <FormError message={errorOf('codigo')} />
            </div>
            <div className="col-12">
                <FormLabel htmlFor="nombre" required>Nombre del perfil</FormLabel>
                <input
                    name="nombre"
                    type="text"
                    placeholder="Nombre del perfil"
                    className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                    value={ formValues.nombre }
                    onChange={ formHandle }
                    disabled={props.disabled}
                />
                <FormError message={errorOf('nombre')} />
            </div>
      </>)}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

PerfilModal.propTypes = {
  id: number.isRequired,
  disabled: bool,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

PerfilModal.defaultProps = {
  disabled: false
};

export default PerfilModal;